export const state = {
	plans: []
}



// WEBPACK FOOTER //
// ./src/common/store/Plans/state.js